/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Instant_Invite_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to invite new people to this server." |
*
* @param {Leveling_Perm_Create_Instant_Invite_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_instant_invite_hint = /** @type {((inputs?: Leveling_Perm_Create_Instant_Invite_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Instant_Invite_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам приглашать на сервер новых людей.")
	return /** @type {LocalizedString} */ ("Allows members to invite new people to this server.")
});